import axios from 'axios';
import { getDelivererApiUrl } from '../../../services/env.service';
import { GetRouteDeclarationFormInformationResponse } from './types';

const delivererApiUrl = getDelivererApiUrl();

class DelivererClient {
  getRouteDeclarationFormInformation() {
    return new Promise<GetRouteDeclarationFormInformationResponse>((resolve, reject) => {
      const url = `${delivererApiUrl}/routes/declaration-form-information`;
      axios
        .get<GetRouteDeclarationFormInformationResponse>(url)
        .then((response) => resolve(response.data))
        .catch((axiosError) => reject(axiosError.message));
    });
  }
}

const delivererClient = new DelivererClient();

export { delivererClient };
